import { Grid } from '@material-ui/core';
import PermissionHide from 'components/PermissionHide';
import React from 'react';
import { useObservable } from 'react-use-observable';
import shoppingService from 'v2/services/shopping/product';

import Approve from './Approve';
import Details from './Details';
import RefundList from './List';
import MassApprove from './MassApprove';
import RefundSelect from './RefundSelected';
import ReproveMotive from './ReproveMotive';

const Refund = () => {
  useObservable(() => shoppingService.loadProducts(), []);

  return (
    <div id={'request-management-refund'}>
      <Grid container spacing={2}>
        <PermissionHide action='myeduzz:request-management:aprovar'>
          <RefundSelect />
        </PermissionHide>

        <Grid item xs={12}>
          <RefundList />
          <PermissionHide action='myeduzz:request-management:detalhes'>
            <Details />
          </PermissionHide>
          <PermissionHide action='myeduzz:request-management:aprovar'>
            <ReproveMotive />
            <Approve />
            <MassApprove />
          </PermissionHide>
        </Grid>
      </Grid>
    </div>
  );
};

export default Refund;
